import api from './api';
import { API_ENDPOINTS } from '../../config/api';

export const feedbackApi = {
  submitFeedback: ({ type, description }) =>
    api.post(API_ENDPOINTS.FEEDBACK, {
      type,
      description,
      pageUrl: window.location.href,
      userAgent: navigator.userAgent,
    }),
};

export default feedbackApi;
